export function formatLocalizedUtcDate(date: Date, locale: string, options: Intl.DateTimeFormatOptions): string {
  return date.toLocaleDateString(locale, { timeZone: 'UTC', ...options });
}

export function formatLocalizedUtcWeekdayDay(date: Date, locale: string): string {
  return formatLocalizedUtcDate(date, locale, { weekday: 'short', day: 'numeric' });
}

export function formatLocalizedUtcTime(date: Date, locale: string): string {
  return date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC',
  });
}
